import { useTranslation } from "react-i18next";

interface Props {
  hotelName: string;
  guestName: string;
}

const ReservationHeader = ({ hotelName, guestName }: Props) => {
  const { t } = useTranslation();

  return (
    <section>
      <h1 className="mb-2 text-xl font-bold">{hotelName}</h1>
      <span>
        <span className="pr-1 font-bold text-purple-700">{guestName}</span>
        {t("welcome")}
      </span>
    </section>
  );
};

export default ReservationHeader;
